import axios from "axios";

//export const BASE_URL = "https://devmerchant.mindandmom.com"; //dev
export const BASE_URL ="https://merchantapi.mimokonnect.in" //prod
export const BUCKET_URL ="https://hms-image-wellness.s3.ap-south-1.amazonaws.com" //dev
//export const BUCKET_URL ="https://prod-hms-wellness-image.s3.ap-south-1.amazonaws.com" //prod
//export const Branch_BUCKET_URL = `https://hms-mnm-hospital.s3.ap-south-1.amazonaws.com`; //dev
export const Branch_BUCKET_URL = `https://hms-mnm-hospital.s3.ap-south-1.amazonaws.com/`; //prod

export default axios.create({
  baseURL: BASE_URL,
});

export const server = axios.create({
  baseURL: `${BASE_URL}`
});

//Get Api's URL...
export const getDashboard = `${BASE_URL}/dashboard`;
export const getCustomer_contact = `${BASE_URL}/customer_contact`;
export const getCustomerApi = `${BASE_URL}/customer`;
export const getBranchApi = `${BASE_URL}/hospital_branch`

export const postregistetHospital = `${BASE_URL}/hospital`
